// extracted by mini-css-extract-plugin
module.exports = {"profileInfo":"style_profileInfo__1dE6d"};